module.exports = "//d274d294w9cx2v.cloudfront.net/826d0796564040bb0731a524077aca93e40f8760/images/photo-couple-wide.png";